import React from 'react';

const Email = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.11914 0C3.19365 0 0 3.19365 0 7.11914C0 11.0446 3.19365 14.2383 7.11914 14.2383H14.0273V27H16.1367V2.10938H21.9375V27H24.0469V2.10938H27V0H7.11914ZM14.0273 12.1289H7.11914C4.35676 12.1289 2.10938 9.88153 2.10938 7.11914C2.10938 4.35676 4.35676 2.10938 7.11914 2.10938H14.0273V12.1289Z"
      fill="#0F1C35"
    />
  </svg>
);

export default Email;
